/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect } from 'react';
import type { ReduxProps } from './TitleAgentInboxContainer';
import { ThreadSectionsGroup } from '../../components/ThreadSectionsGroup';
import { ThreadGroups } from '../../types';
import { useParams } from 'react-router-dom';

export namespace TitleAgentInbox {
  export interface Props {
    threadsByGroup: ThreadGroups;
  }
}
export const TitleAgentInbox: React.FC<TitleAgentInbox.Props & ReduxProps> = ({
  getThreadsForLoan,
  threadsByGroup,
}) => {
  const { loanId } = useParams<{ loanId: string }>();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async () => {
      await getThreadsForLoan(loanId);
    })();
  }, []);

  return (
    <div data-it="TitleAgentInboxWrapper">
      <ThreadSectionsGroup threadGroups={threadsByGroup} />
    </div>
  );
};
